import type { MechanicalDamageType } from '../types.js';
import type { SkillAssetCatalogEntryV1, SkillAssetRoleV1, SkillVisualBindingV1 } from './skill-asset-specs-v1.js';

/**
 * Element asset families for generated skills: one asset per role for each
 * mechanical damage type. The art is non-product placeholder colour until
 * real art replaces the files; keys and roles are the stable contract.
 */
export const SKILL_ASSET_ELEMENTS_V1: readonly MechanicalDamageType[] = Object.freeze(['physical', 'fire', 'cold', 'lightning', 'toxic', 'arcane']);
const ROLES: readonly SkillAssetRoleV1[] = ['BODY', 'AREA', 'IMPACT', 'TRAIL', 'CAST'];

export function elementSkillAssetBinding<R extends SkillAssetRoleV1>(element: MechanicalDamageType, role: R): SkillVisualBindingV1<R> {
  return { role, assetKey: `element.${element}.${role.toLowerCase()}` };
}

export const ELEMENT_SKILL_ASSET_CATALOG_V1: readonly SkillAssetCatalogEntryV1[] = Object.freeze(SKILL_ASSET_ELEMENTS_V1.flatMap((element) =>
  ROLES.map((role) => Object.freeze({ ...elementSkillAssetBinding(element, role), file: `elements/${element}/${role.toLowerCase()}.png` }))));
